<template>
  <div>
    <div class="card">
      <div class="card-content">
        <vue-element-loading :active="isLoading" spinner="spinner" />
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th width="30%">{{ $t("DateTime") }}({{ timezone }})</th>
              <th width="30%">{{ $t("devices.deviceId") }}</th>
              <th>{{ $t("devices.deviceLocate") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, deviceId) in eventsList"
              :key="deviceId"
              class="movie-link"
              @click="
                playMovie(
                  item.deviceLocate,
                  item.datetime,
                  item.file,
                  item.tenantId,
                  item.projectId,
                  userId,
                  item.deviceId
                )
              "
            >
              <td class="movie-link">
                <DateFormat :timestamp="item.eventDateTime" />
              </td>
              <td>{{ item.deviceId }}</td>
              <td>{{ item.deviceLocate }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="eventsList.length > 4" class="has-text-centered">
          <router-link
            :to="{
              name: 'eventsList',
              params: {
                projectId: projectId,
              },
            }"
          >
            {{ $t("events.allData") }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="modal" v-bind:class="{ 'is-active': modal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ movieTitle }}</p>
          <button
            class="delete"
            aria-label="close"
            @click="modalChange()"
          ></button>
        </header>
        <section class="modal-card-body">
          <figure class="image" v-html="movieUrl" style="width: 100%"></figure>
          <div class="has-text-centered">
            {{ movieInfo.deviceId }} |
            <DateFormat :timestamp="movieInfo.datetime" /> ({{ timezone }}) |
            <a download @click="movieDownload()">
              <i class="fas fa-cloud-download-alt"></i>
              {{ $t("movie.download") }}</a
            >
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="modalChange()">Close</button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import imsr from "@/imsr-api";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import imsrconfig from "@/imsr-exports";
import VueElementLoading from "vue-element-loading";
import DateFormat from "@/components/DateFormat.vue";

export default {
  components: {
    VueElementLoading,
    DateFormat,
  },
  props: {
    tenantId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
    limit: {
      type: Number,
      default: 10,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const eventsList = ref([]);
    const modal = ref(false);
    const movieUrl = ref("");
    const movieTitle = ref("");
    const movieInfo = ref("");
    const movieLink = ref({});
    const isLoading = ref(false);
    const getList = async () => {
      try {
        isLoading.value = true;
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
          limit: props.limit,
        };
        const res = await imsr.imsrGetApi("/events/list", params);
        res.events.forEach((item) => {
          eventsList.value.push({
            datetime: item.eventDateTime,
            deviceId: item.deviceId,
            deviceLocate: item.deviceLocate,
            file: item.file,
            tenantId: item.tenantId,
            projectId: item.projectId,
            eventDateTime: item.eventDateTime,
          });
        });
        isLoading.value = false;
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };
    getList();

    const modalChange = () => {
      modal.value = !modal.value;
      if (modal.value === false) {
        movieUrl.value = "";
      }
    };

    const playMovie = async (
      locate,
      date,
      file,
      tenantId,
      projectId,
      userId,
      deviceId
    ) => {
      try {
        const params = {
          tenantId: tenantId,
          projectId: projectId,
        };
        const ticket = await imsr.imsrGetApi("/projects/getTicket", params);
        const query =
          "?userId=" +
          userId +
          "&tenantId=" +
          tenantId +
          "&projectId=" +
          projectId +
          "&ticket=" +
          ticket.movieTicket +
          "&time=" +
          ticket.time;
        const url = encodeURI(imsrconfig.movie + file + query).replace(
          "+",
          "%2B"
        );
        movieUrl.value =
          '<video class="movie-file" controlslist="nodownload" controls autoplay muted preload="on" poster="' +
          '/img/blank.png">' +
          '<source src="' +
          url +
          '" type="video/mp4"/>' +
          "</video>";

        movieTitle.value = locate;
        movieInfo.value = {
          datetime: date,
          deviceId: deviceId,
        };
        movieLink.value = {
          tenantId: tenantId,
          projectId: projectId,
          userId: userId,
          file: file,
        };
        modal.value = true;
      } catch (error) {
        router.push({ name: "InternalServerError" });
      }
    };

    const movieDownload = async () => {
      const params = {
        tenantId: movieLink.value.tenantId,
        projectId: movieLink.value.projectId,
      };
      const ticket = await imsr.imsrGetApi("/projects/getTicket", params);
      const query =
        "?userId=" +
        movieLink.value.userId +
        "&tenantId=" +
        movieLink.value.tenantId +
        "&projectId=" +
        movieLink.value.projectId +
        "&ticket=" +
        ticket.movieTicket +
        "&time=" +
        ticket.time;
      const url = encodeURI(
        imsrconfig.movie + movieLink.value.file + query
      ).replace("+", "%2B");
      window.open(url, "_blank");
    };
    return {
      userId: computed(() => store.getters.userId),
      timezone: computed(() => store.getters.timezone),
      eventsList,
      modalChange,
      playMovie,
      movieDownload,
      modal,
      movieUrl,
      movieTitle,
      movieInfo,
      isLoading,
    };
  },
};
</script>

<style scoped>
.movie-link {
  cursor: pointer;
}
.movie-file {
  width: 100%;
}
</style>
